import React, { useEffect } from "react";
import Header from "../../common/header/Header";
import "../../../assets/styles/containers/_dashboard.scss";
import { Box } from "@mui/system";
import Breadcrumb from "../../common/header/Breadcrumb";
import DashboardLayout from "./Layout";
import { useNavigate } from "react-router-dom";
import toast  from 'react-hot-toast';


const Dashboard = (props) => {
  let navigate = useNavigate();

  useEffect(() => {
    const companyKey = sessionStorage.getItem("company-key");
    const hasCompanyKey = Boolean(companyKey && companyKey !== "null" && companyKey !== "undefined");

    if (!sessionStorage.getItem("token") && !hasCompanyKey) {
      navigate("/");
      toast.error("sign in to see the contents");
    }
  });
  
  useEffect(() => {
          window.scrollTo(0, 0);
      }, []);
  
  return (
    <>
    {/* {console.log(props.userName , "data")} */}
      <Box sx={{ flexGrow: 1 }} className="page-background">
        <Header />
        <Breadcrumb />
        <DashboardLayout />
      </Box>
    </>
  );
};

export default Dashboard;
